import axios, { AxiosInstance } from 'axios';
import { NoticeClass } from '../store/modules/types/Notice';
import Alert from '../store/modules/types/Alert';
import { Store } from 'vuex';

export default class FBaseService {

	readonly AUTH_LOGIN_CALLBACK = '/api/auth/login?callback=';
	readonly LEGACY_LOGIN_CALLBACK = '/auth/login?callback=';

	protected apiClient: AxiosInstance;

	protected useApi = true;

	protected store: Store<Record<string, unknown>> | null;

	constructor(store: Store<Record<string, unknown>> | null = null, useApi = true) {
		this.store = store;
		this.useApi = useApi;
		this.apiClient = axios.create({});
		this.apiClient.interceptors.response.use(resp => (resp), e => {
			switch (e.response.status) {
				case 401:
					this.handleUnauthenticated(window.location.pathname + window.location.hash);
					break;
				case 403:
					this.handleForbidden();
					break;
				case 500:
					this.hanldeServerError();
					break;
			}
			return Promise.reject(e);
		});
	}

	protected async handleForbidden(): Promise<void> {
		const msg = 'You are not authorized to perform this action.';
		if (this.store !== null) {
			const al = new Alert(msg, NoticeClass.ERROR);
			await this.store.dispatch('notices/add', al);
		} else {
			alert(msg);
		}
	}
	
	protected async handleUnauthenticated(url: string): Promise<void> {
		const msg = 'Your session has expired. Log in again.';
		if (this.store !== null) {
			const al = new Alert(msg, NoticeClass.INFO);
			await this.store.dispatch('notices/add', al);

			// redirect on any action by user
			window.location.assign(this.getAuthLoginCallbackUrl(url));

		} else {
			alert(msg);
			window.location.assign(this.getAuthLoginCallbackUrl(url));
		}
	}

	protected getAuthLoginCallbackUrl(url: string) {
		return this.useApi ? `${this.AUTH_LOGIN_CALLBACK}${url}` : `${this.LEGACY_LOGIN_CALLBACK}${url}`;
	}

	protected async hanldeServerError(): Promise<void> {
		const msg = 'Application error, try again.';
		if (this.store !== null) {
			const al = new Alert(msg, NoticeClass.INFO);
			await this.store.dispatch('notices/add', al);
		} else {
			alert(msg);
		}
	}
}